<template>
  <footer class="sm-footer">
    <div class="sm-footer-left">
      <div class="sm-footer-left-col">
        <h5 class="sm-txt-capitalize">{{providerName}}</h5>
        <a
          v-if="provider.terms_of_service_url || provider.terms_of_service_external_url"
          :href="provider.terms_of_service_url || provider.terms_of_service_external_url"
          class="sm-text-link"
          target="_blank"
        >Terms of service</a>
      </div>
      <div class="sm-footer-left-col">
        <div class="sm-footer-left-col-item">
          <include-svg :name="'icon-footer-location'" />
          <p v-if="providerAddress.line_1">{{providerAddress.line_1}}</p>
          <p>
            <template v-if="providerAddress.line_2">{{providerAddress.line_2}}</template>
            <template v-if="providerAddress.line_3">, {{providerAddress.line_3}}</template>
          </p>
        </div>
        <div 
          v-if="providerPhone"
          class="sm-footer-left-col-item"
        >
          <include-svg :name="'icon-footer-number'" />
          <span>{{providerPhone}}</span>
        </div>
      </div>
      <div  v-if="providerPhone">
        <qr-code 
          :text="`tel: ${providerPhone}`"
          :size="80"
          bg-color="#EDEDED"
          color="#545356" 
          >
        </qr-code>
      </div>
    </div>
    <div v-if="Object.keys(provider).length && !provider.vanity_domain_custom" class="sm-footer-right">
      <a 
        :href="homeLink" 
        class="sm-footer__logo"
        target="_blank"
      >
        <include-svg :name="'logo-spheremail-footer'" />
      </a>
      <div class="sm-footer-right-row">
        <div class="sm-footer__rights">
          <span>SphereMail, Inc. ©2011-{{new Date().getFullYear()}}</span>
          <span>All rights reserved</span>
        </div>
        <div 
          class="sm-footer__controls"
          v-click-outside="hideLinks"
        >
          <a
            href="#"
            class="sm-footer__controls-link"
            @click.prevent="showLinks = !showLinks"
          >
            <include-svg :name="'icon-footer-link'" />
          </a>
          <ul 
            v-if="showLinks"
            class="sm-footer__controls-list"
          >
            <li
              v-for="item in controls"
              :key="item.link"
            >
              <a
                :href="item.link"
                target="_blank"
                class="sm-text-link"
              >{{item.text}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Urls from '@/settings/urls';
import ProviderAddress from '@/mixins/ProviderAddress';
import { mapGetters, mapActions } from 'vuex';
import vClickOutside from 'v-click-outside';
import VueQRCodeComponent from 'vue-qrcode-component'

export default {
  name: 'footer-elem',
  components: {
    'qr-code': VueQRCodeComponent, 
  },
  data() {
    return {
      homeLink: Urls.links.home,
      controls: [
        {
          text: 'About',
          link: Urls.links.about
        },
        {
          text: 'Terms of service',
          link: Urls.links.terms
        },
        {
          text: 'Privacy policy',
          link: Urls.links.policy
        },
        {
          text: 'Careers',
          link: Urls.links.careers
        }
      ],
      showLinks: false,
    }
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    })
  },
  mixins: [ProviderAddress],
  methods: {
    hideLinks() {
      this.showLinks = false;
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>
